import { Heading } from '@chakra-ui/react'
import CountryRiskDataTableHandler from '@Modules/fraudManagement/containers/dataTableHandlers/globalSettings/countryRisk/CountryRiskDataTableHandler'

const CountryRiskPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>Risque Pays</Heading>
      <CountryRiskDataTableHandler />
    </>
  )
}

export default CountryRiskPage